import { IRootState } from './index';
import { IPaymentMethodState } from './paymentMethod.types';

export const selectPaymentMethods = ({ paymentMethod }: IRootState): IPaymentMethodState => paymentMethod;
